import type { FC } from 'react'

import { Input } from 'antd'

import { Label } from 'common/components/Label/Label'
import { INPUT_PLACEHOLDER } from 'common/constants/inputConstants'
import type { ITextarea } from 'common/interfaces/ITextarea'

import styles from './textarea.module.scss'

const AntTextarea = Input.TextArea

export const Textarea: FC<ITextarea> = ({ label, name, required, ...rest }) => {
  return (
    <div className={styles.parent}>
      <Label id={name} required={required} label={label} />
      <div className={styles.parentContainer}>
        <AntTextarea rows={4} placeholder={INPUT_PLACEHOLDER.TYPE_HERE} {...rest} />
      </div>
    </div>
  )
}
